import { useFetcher } from '@remix-run/react'

import { type GetAddress } from '~/models/ecommerce-providers/sylius/shop/fetch/address/get-address.ts'
import { PROFILE_ADDRESSES_ID_FORM } from '~/routes/($lang).profile.addresses.$id/edit.component'

type useOptimisticAddressProps = GetAddress & {
	id: number
}

function useOptimisticAddress({
	id,
	...rest
}: useOptimisticAddressProps): GetAddress {
	const editAddressFetcher = useFetcher({
		key: PROFILE_ADDRESSES_ID_FORM.generateFetcherKey!({ id: String(id) }),
	})

	return {
		...rest,
		...(editAddressFetcher.formData
			? Object.fromEntries(editAddressFetcher.formData.entries())
			: {}),
	}
}

export { useOptimisticAddress }
